// Page scrolled Waypoint
(function () {
  function handler(direction) {
    if (direction === "down") {
      document.body.classList.add("page-scrolled");
    } else if (direction === "up") {
      document.body.classList.remove("page-scrolled");
    }
  }

  // // For page-scrolled behaviour for menus page to play better with ignite menus plugin
  // if (document.body.classList.contains("page-id-101")) {
  //   document.body.classList.add("page-scrolled");
  // }

  function offset() {
    return -0.3333 * window.innerHeight;
  }

  new Waypoint({
    element: document.querySelector("main"),
    handler: handler,
    offset: offset,
  });
})();
